import * as React from 'react';
import { useIntl } from 'react-intl';

import { GetCatalogProductViewQuery } from '@notino/shared/definitions/types';

import { useApolloClientHeaders } from '@hooks/useApolloClientHeaders';

import { messages } from '../ProductBaseInfo/VoucherDiscount/VoucherDiscountInfo/messages';
import { pictogramMoreInfoPathname } from '../ProductTabContent/Pictograms/messages';

import {
  DermoLink,
  RecomendedByDermatologistsIcon,
  StyledPowerOfBeautyIcon,
  StyledSummerBlackFridayIcon,
} from './styled';

interface IProductPictogramProps {
  attributes: GetCatalogProductViewQuery['productDetailByCatalogMasterId']['variants'][number]['attributes'];
}

export const ProductPictogram: React.FC<IProductPictogramProps> = ({
  attributes,
}) => {
  const { formatMessage } = useIntl();
  const dermoMoreInfoPathname = formatMessage(pictogramMoreInfoPathname);
  const isFranceShop = useApolloClientHeaders().shopId === 'notino.fr';

  const shouldShowSummerBlackFriday =
    attributes.VoucherDiscount?.tags.includes('summerblackfriday');

  return (
    <>
      {shouldShowSummerBlackFriday && (
        <StyledSummerBlackFridayIcon
          highlightedWordIndex={isFranceShop ? 2 : 0}
          text={formatMessage(messages.sbfLabel)}
          data-testid="summerBlackFridayIcon-pictogram"
        />
      )}

      {attributes?.LorealLabel && (
        <StyledPowerOfBeautyIcon data-testid="powerOfBeauty-pictogram" />
      )}

      {attributes?.Dermo && (
        <DermoLink target="_blank" href={dermoMoreInfoPathname}>
          <RecomendedByDermatologistsIcon data-testid="dermo-pictogram" />
        </DermoLink>
      )}
    </>
  );
};
